
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke-linecap":"round","stroke-width":"1.5","stroke":"#000","fill":"none","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M12 23.25v-15M16.502 12.751l-4.5-4.5-4.5 4.5"}}),_c('path',{attrs:{"d":"M8.252 19.5H5.99l-.01-.001c-1.66-.01-3-1.35-3-3V3.74h0A2.996 2.996 0 015.97.73h12-.01c1.65-.01 3 1.34 3 3v12.74c0 1.65-1.35 3-3 3h-2.25"}})])])
          )
        }
      }
    